<template>
  <div>
    <v-row>
      <v-col class="min-width-7" cols="7">
        <FormConjugation ref="form" />
      </v-col>
      <v-col class="min-width-4 max-width-4 ml-10 p-0 pb-2" cols="4">
        <div class="template-show pa-3">
          <TemplateConjugation :no="this.$route.query.no" />
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-btn color="primary" class="ml-10" @click="checkValidate">{{
        $t("UPDATE")
      }}</v-btn>
      <Dialog v-model="dialogConfirmUpdate" :title="$t('COMFIRMATION')">
        <template v-slot:content>更新します。よろしいですか。</template>
        <template v-slot:actions>
          <v-btn color @click="dialogConfirmUpdate = false" small>{{
            $t("CANCEL")
          }}</v-btn>
          <v-btn
            :disabled="loaddingUpdateGeneral"
            color="primary"
            small
            :loading="loaddingUpdateGeneral"
            @click="handleUpdateQuestion"
            >{{ $t("OK") }}</v-btn
          >
        </template>
      </Dialog>

      <v-btn color class="ml-10" @click="back">{{ $t("BACK") }}</v-btn>
    </v-row>
  </div>
</template>

<script>
import FormConjugation from "@/views/drill/Exercises/FormConjugation.vue";
import TemplateConjugation from "@/views/drill/Exercises/TemplateConjugation.vue";
import { getDetailQuestion, updateQuestion } from "@/api/Pratice.api";
import mixin from "@/mixin";
import Dialog from "@/components/Dialog/Dialog";
export default {
  store: ["formGeneral"],
  mixins: [mixin.ValidateGeneral],
  components: {
    FormConjugation,
    TemplateConjugation,
    Dialog,
  },
  data() {
    return {
      probleType: [
        { text: "語彙・文法：4択", type: "write", key: "Choices" },
        { text: "語彙・文法：並び替え", type: "write", key: "Sort" },
        { text: "語彙・文法：ダイヤル入力", type: "write", key: "Conjugation" },
        { text: "漢字読み", type: "write", key: "Kanji" },
        { text: "短文聴解", type: "listen", key: "ShortSentences" },
        { text: "長文聴解", type: "listen", key: "LongSentences" },
      ],
      dialogConfirmUpdate: false,
      loaddingUpdateGeneral: false,
    };
  },
  async created() {
    await this.handleGetDetail();
  },
  methods: {
    async handleGetDetail() {
      const { drillId, exerciesID } = this.$route.params;
      let params = {
        sub_key: drillId,
        id: exerciesID,
      };
      await getDetailQuestion(params).then((response) => {
        const {
          lead_sentence,
          verb,
          list_answer,
          answer_correct,
        } = response.result;
        this.formGeneral.leadSentence = lead_sentence;
        this.formGeneral.name1 = list_answer.sentence_answer[0];
        this.formGeneral.name2 = list_answer.sentence_answer[1];
        this.formGeneral.verb = verb;
        this.formGeneral.answersConjugation = list_answer.answer[0];
        this.formGeneral.wrongAnswersConjugation = list_answer.answer[1];
        this.formGeneral.isAnsewr = answer_correct[0];
      });
    },
    async handleUpdateQuestion() {
      this.loaddingUpdateGeneral = true;
      const { exerciesID } = this.$route.params;
      let params = await this.$refs.form.getParams();

      if (params) {
        params.id = exerciesID;
        await updateQuestion(params)
          .then(async () => {
            this.dialogConfirmCreate = false;
            this.back();
          })
          .catch((error) => {
            this.loaddingUpdateGeneral = false;
            this.$toast.error(error);
          });
      } else {
        this.loaddingUpdateGeneral = false;
        this.dialogConfirmUpdate = false;
      }
    },
    back() {
      const {
        query,
        params: { drillId },
      } = this.$route;
      this.$router.push({
        name: "List Exercises Of Drill",
        query,
        params: { drillId },
      });
    },
    async checkValidate() {
      let params = await this.$refs.form.getParams();
      if (params) {
        this.dialogConfirmUpdate = true;
      }
    },
  },
  beforeDestroy() {
    this.formGeneral = {
      leadSentence: "",
      name1: "",
      name2: "",
      isAnsewr: 1,
      verb: "",
      kanji: "",
      audio: null,
      image: null,
      script: "",
      sub_question: {
        question1: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
        question2: {
          answers: [
            {
              id: 1,
              name: "回答1",
              value: "",
            },
            {
              id: 2,
              name: "回答2",
              value: "",
            },
            {
              id: 3,
              name: "回答3",
              value: "",
            },
            {
              id: 4,
              name: "回答4",
              value: "",
            },
          ],
          script: "",
          audio: null,
          isAnsewr: 1,
        },
      },
      answers: [
        {
          id: 1,
          name: "回答1",
          value: "",
        },
        {
          id: 2,
          name: "回答2",
          value: "",
        },
        {
          id: 3,
          name: "回答3",
          value: "",
        },
        {
          id: 4,
          name: "回答4",
          value: "",
        },
      ],
      answersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
      wrongAnswersConjugation: [
        {
          id: 1,
          value: "",
        },
        {
          id: 2,
          value: "",
        },
        {
          id: 3,
          value: "",
        },
        {
          id: 4,
          value: "",
        },
      ],
    };
  },
};
</script>
<style>
.col-lable {
  min-width: 120px;
  max-width: 120px;
}
</style>
<style lang="scss" scoped>
#Audio {
  height: 40px;
  margin-top: 4px;
}
.template-show {
  border: 1px solid #ccc;
}
</style>
